import React from "react";
import { Box, IconButton, Stack, Tooltip } from "@chakra-ui/core";
import NewPaymentLink from "../forms/NewPaymentLink";
import CancelLink from "../common/CancelLink"
import FullOrderDetailsView from "../common/FullOrderDetailsView";
import { FaPlus } from "react-icons/fa";
import { MdRemoveRedEye, MdCancel } from "react-icons/md";

const ActionList = ({ order, refetch, currentSection = "orders", status }) => {
  const [isCreateLink, setIsCreateLink] = React.useState(false);
  const [isViewOrderDetails, setIsViewOrderDetails] = React.useState(false);
  const [isCancelLink, setIsCancelLink] = React.useState(false);

  const handleOrderCancellation = () => {
    setIsCancelLink(true)
  }

  const { customer } = order;
  return (
    <Stack spacing={0} justifyContent="center" isInline flexWrap="wrap">
      {currentSection === "orders" && (
        <Box my={1} >
          <Tooltip
            hasArrow
            label="View order details"
            bg="info.400"
            placement="top"
          >
            <IconButton
              variant="outline"
              size="sm"
              aria-label="Add new link icon"
              _hover={{
                bg: "none",
                color: "primary.600",
              }}
              icon={MdRemoveRedEye}
              onClick={() => setIsViewOrderDetails(true)}
            />
          </Tooltip>
        </Box>
      )}

      <Box my={1} mx={1}>
        <Tooltip
          hasArrow
          label="Create a new link"
          bg="info.400"
          placement="top"
        >
          <IconButton
            variant="outline"
            size="sm"
            aria-label="Add new link icon"
            _hover={{
              bg: "none",
              color: "primary.600",
            }}
            icon={FaPlus}
            onClick={() => setIsCreateLink(true)}
          />
        </Tooltip>
      </Box>
      {
        status === "pending" &&
        <Box my={1} mx={1}>
        <Tooltip
          hasArrow
          label="Cancel this link"
          bg="info.400"
          placement="top"
        >
          <IconButton
            variant="outline"
            size="sm"
            aria-label="Add new link icon"
            color="danger.300"
            _hover={{
              bg: "none",
              color: "danger.600",
            }}
            icon={MdCancel}
            onClick={handleOrderCancellation}
          />
        </Tooltip>
      </Box>
      }
      {isCreateLink && (
        <NewPaymentLink
          intialStep="2"
          {...{ customer, isCreateLink, setIsCreateLink, refetch }}
        />
      )}
      {isViewOrderDetails && (
        <FullOrderDetailsView
          {...{ order, setIsViewOrderDetails, isViewOrderDetails }}
        />
      )}
      {
        isCancelLink && (
          <CancelLink {...{order, setIsCancelLink, isCancelLink, refetch}} />
        )
      }
    </Stack>
  );
};

export default ActionList;
